import React from 'react';
import Button from '@material-ui/core/Button';
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';
import css from '../../containers/Pickup/index.module.scss';

function OrderModesHeadingDesktop({ heading, closePopUp }) {
  return (
    <div className={css.desktopHeader}>
      {/* <div className={css.icon}>
        <img src={`${IconURL}`} alt="" />
      </div> */}
      <div className={css.heading}>{heading}</div>
      <div className={css.Closebutton}>
        <Button onClick={closePopUp}>
          <IoMdClose />
        </Button>
      </div>
    </div>
  );
}

export default OrderModesHeadingDesktop;
